import {
  GET_HOSTED_PAGE_SUCCESS,
  GET_HOSTED_PAGE_FAILURE,
  GET_CREDENTIAL_FROM_HOSTED_PAGE_SUCCESS,
  GET_CREDENTIAL_FROM_HOSTED_PAGE_FAILURE,
} from './actions';

const initialState = {
  getHostedPageResult: {
    success: true,
  },
  credentials: {
    isLoaded: false,
    success: true,
  },
};

const value = (state = initialState, action) => {
  switch (action.type) {
    case GET_HOSTED_PAGE_SUCCESS:
      return { ...state, getHostedPageResult: { success: true, ...action.payload } };
    case GET_HOSTED_PAGE_FAILURE:
      return { ...state, getHostedPageResult: { success: false, ...action.payload.error } };
    case GET_CREDENTIAL_FROM_HOSTED_PAGE_SUCCESS:
      return { ...state, credentials: { success: true, isLoaded: true, ...action.payload } };
    case GET_CREDENTIAL_FROM_HOSTED_PAGE_FAILURE:
      return { ...state, credentials: { success: false, isLoaded: true, ...action.payload.error } };
    default:
      return state;
  }
};

export default value;
